import { Directive, HostListener, inject, OnInit } from '@angular/core';
import { Router, RouterLink, UrlSegment, UrlSegmentGroup } from '@angular/router';
import { LanguageService } from '../../services/language/language.service';
import { isPathInRoutes } from '../../factories/route-resolver.function';
import { VanillaRoutingService } from '../../services/vanilla-routing.service';

@Directive({
  selector: 'a[routerLinkWithLang]',
  standalone: true,
})
export class RouterLinkWithLang implements OnInit {
  private readonly routerLink = inject(RouterLink);
  private readonly router = inject(Router);
  private readonly languageService = inject(LanguageService);
  private readonly vanillaRoutingService = inject(VanillaRoutingService);

  ngOnInit() {
    const routeLang = this.languageService.getCurrentRouteLang();
    if (!routeLang) {
      return;
    }

    const urlTree = this.routerLink.urlTree;
    if (!urlTree.root.children.primary) {
      urlTree.root.children.primary = new UrlSegmentGroup([], {});
    }
    urlTree.root.children.primary.segments.unshift(new UrlSegment(routeLang, {}));
    this.routerLink.fragment = undefined;
    this.routerLink.queryParams = null;
    this.routerLink.queryParamsHandling = null;
    this.routerLink.preserveFragment = null;
    this.routerLink.relativeTo = null;
    this.routerLink.routerLink = urlTree;
    this.routerLink['ngOnChanges']();
  }

  @HostListener('click', [
    '$event.button',
    '$event.ctrlKey',
    '$event.shiftKey',
    '$event.altKey',
    '$event.metaKey',
  ])
  onClick(
    button: number,
    ctrlKey: boolean,
    shiftKey: boolean,
    altKey: boolean,
    metaKey: boolean,
  ): boolean {
    if (button !== 0 || ctrlKey || shiftKey || altKey || metaKey) {
      return true;
    }

    if (typeof this.routerLink.target === 'string' && this.routerLink.target != '_self') {
      return true;
    }

    if (!isPathInRoutes(this.routerLink.href, this.router.config)) {
      this.vanillaRoutingService.isVanillaRoutingInProgress = true;
      window.location.assign(this.routerLink.href);
      return false;
    }
  }
}
